// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__input-wrapper-a9brEM {
  flex-direction: column;
  width: 100%;
  display: flex;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__input-wrapper-a9brEM > *, .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__input-wrapper-a9brEM span {
  width: 100%;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__error-content-yl1WPm {
  height: 20px;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__error-float-Kr8qU7 {
  width: 100%;
  position: absolute;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__error-text-p2XNVV {
  color: var(--semi-color-danger);
  font-family: SF Pro Display, -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 22px;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__input-zBTotH input {
  text-overflow: ellipsis;
  overflow: hidden;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__limit-count-UBFzWU {
  color: var(--light-usage-text-color-text-3, rgba(28, 31, 35, .35));
  padding-left: 8px;
  padding-right: 12px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  overflow: hidden;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input-wrapper": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__input-wrapper-a9brEM`,
	"inputWrapper": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__input-wrapper-a9brEM`,
	"error-content": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__error-content-yl1WPm`,
	"errorContent": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__error-content-yl1WPm`,
	"error-float": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__error-float-Kr8qU7`,
	"errorFloat": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__error-float-Kr8qU7`,
	"error-text": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__error-text-p2XNVV`,
	"errorText": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__error-text-p2XNVV`,
	"input": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__input-zBTotH`,
	"limit-count": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__limit-count-UBFzWU`,
	"limitCount": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-input-index-module__limit-count-UBFzWU`
};
export default ___CSS_LOADER_EXPORT___;
